"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Defines a gender
 * @type {{MALE: string, FEMALE: string, NON_BINARY: string, PREFER_NOT_TO_SAY: string}}
 */
const gender = {
    MALE: 'male',
    FEMALE: 'female',
    NON_BINARY: 'non-binary',
    PREFER_NOT_TO_SAY: 'prefer not to say'
};
exports.default = gender;
//# sourceMappingURL=gender.js.map